var firebaseConfig = {
  apiKey: "AIzaSyAXNvYDTBbOhk3XvdcxBk7-3fVOWHUeAiw",
  authDomain: "punto5academia.firebaseapp.com",
  databaseURL: "https://punto5academia.firebaseio.com",
  projectId: "punto5academia",
  storageBucket: "punto5academia.appspot.com",
  messagingSenderId: "865784301453",
  appId: "1:865784301453:web:50c6fb3131c44ccd691fc4",
  measurementId: "G-V9LE8NSBXZ"
};

  export default firebaseConfig
